<template>
  <d-list-group>
    <d-list-group-item v-for="(row, index) in items" :key="index" class="d-flex px-3">
      <span class="prepend">{{ prepend }}</span>
      <d-input v-model="row.value" class="input-hidden" :placeholder="placeholder"/>
      <span class="ml-auto text-right text-semibold col-auto px-0">
        <i class="fas fa-plus" @click="addRow(index+1)" v-if="index+1 == items.length"></i>
        <i class="fas fa-minus" @click="removeRow(row.index)"></i>
      </span>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { FILTER_ITEMS } from '../FeedModel';

export default {
  name: 'feed-filter-modal',
  components: {
  },
  props: {
    type: {
      type: String,
      default: 'user',
    },
    prepend: {
      type: String,
      default: '@',
    },
    items: {
      type: Array,
      default: () => [{ ...FILTER_ITEMS, ...{ type: this.type } }],
    },
    placeholder: {
      type: String,
      default: 'Adicione um novo usuario',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    list: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit('update:items', value);
      },
    },
  },
  methods: {
    addRow(index) {
      this.items.push({ ...FILTER_ITEMS, ...{ type: this.type, index } });
    },
    checkEmptyOptions() {
      if (this.items.length === 0) {
        this.addRow(0);
      }
    },
    removeRow(id) {
      const index = this.list.findIndex(item => item.index === id && item.type === this.type);
      this.items.splice(index, 1);
      this.checkEmptyOptions();
    },
  },
  mounted() {
    if (this.items.length === 0) {
      this.addRow(0);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}
.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
